import BookingsContent from '../components/bookings/BookingsContent';
import BookingsHead from "../components/bookings/BookingsHead";

export default function Bookings() {
  return (
    <>
      <BookingsHead />
      <BookingsContent />
    </>
  );
}